export default __webpack_public_path__ + "static/media/shibaswap-icon.ee749b42.png";